import type { Batch } from '@/types/batch-types'
import { useForm } from 'vee-validate'
import { toTypedSchema } from '@vee-validate/zod'
import { batchSchema, sendToSupplierSchema } from '@/schemas/batchSchema'
import { onMounted, ref } from 'vue'
import { getBatchById } from '@/api/batches'
import { useToast } from 'primevue/usetoast'
import { useRouter } from 'vue-router'

export const useBatchForm = (formType: 'add' | 'edit' | 'view'): any => {
  const { values, handleSubmit, errors, setErrors, resetForm, meta, setFieldValue } = useForm({
    validationSchema: toTypedSchema(batchSchema)
  })
  const toast = useToast()
  const loading = ref(false)
  const router = useRouter()

  const showToast = (type: 'success' | 'error', title: string, message: string) => {
    toast.add({
      severity: type,
      summary: title,
      detail: message,
      life: 5000
    })
  }

  onMounted(async () => {
    if (formType !== 'add') {
      const batchId = router.currentRoute.value.params.id as string
      const batch: any = await getBatchById(batchId)

      if (batch) {
        resetForm({
          values: { ...batch }
        })
      }
    }
  })

  return {
    values,
    handleSubmit,
    errors,
    setErrors,
    resetForm,
    meta,
    setFieldValue,
    showToast,
    formType,
    loading
  }
};

export const useSendBatchToSupplierForm = (): any =>  {
  const { values, handleSubmit, errors, setErrors, resetForm, meta } = useForm({
    validationSchema: toTypedSchema(sendToSupplierSchema)
  })
  const toast = useToast()

  const showToast = (type: 'success' | 'error', title: string, message: string) => {
    toast.add({
      severity: type,
      summary: title,
      detail: message,
      life: 5000
    })
  }

  return  {
    values,
    handleSubmit,
    errors,
    setErrors,
    resetForm,
    meta,
    showToast
  }
}

